export default __webpack_public_path__ + "static/media/BAKA_ikona_web-01.a9cd9834.svg";